import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type EventDeliveryAddressFragment = { __typename?: 'EventDeliveryAddress', id: string, name?: string | null, event_id?: string | null, is_event_default: boolean, linked_item_location_count: number, additional_info?: string | null, streetname?: string | null, streetno?: string | null, city?: string | null };

export const EventDeliveryAddressFragmentDoc = gql`
    fragment EventDeliveryAddress on EventDeliveryAddress {
  id
  name
  event_id
  is_event_default
  linked_item_location_count
  additional_info
  streetname
  streetno
  city
}
    `;